export default __webpack_public_path__ + "static/media/Punto_09_Mercato_Centrale_ITA_Def.73ee4551.aac";